import React, { useState, useEffect } from 'react';
import './SearchBar.css';

function SearchBar({ onSearch }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedTerm, setDebouncedTerm] = useState(searchTerm);
  const [isLoading, setIsLoading] = useState(false);

  // Update debounced value after 1 second of inactivity
  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setDebouncedTerm(searchTerm);
      setIsLoading(false);
    }, 1000);

    // Clear timeout if searchTerm changes before the delay has passed
    return () => {
      clearTimeout(timer);
    };
  }, [searchTerm]);

  // Trigger search when debounced term changes
  useEffect(() => {
    // We want to search even if the term is empty (to show all products)
    if (onSearch) {
      onSearch(debouncedTerm);
    }
  }, [debouncedTerm, onSearch]);

  const handleSearch = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (onSearch) {
      onSearch(searchTerm);
    }
    // Set loading back to false after a short delay
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };


  return (
    <div className="search-container">
      <form onSubmit={handleSearch}>
        <input
          type="text"
          className="search-input"
          placeholder="Search for products..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button type="submit" className={`search-button ${isLoading ? 'loading' : ''}`}>
          {isLoading ? <div className="spinner"></div> : 'Search'}
        </button>
      </form>
    </div>
  );
}

export default SearchBar;
